import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const WORKFRONTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.WorkFrontType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.WorkFrontType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .number('quantityHv', 'Entity.WorkFrontType.QuantityHV')
    .required()
    .min(0)
    .max(99999999.99)
    .decimal(2,10)
    .build(),
];

export const WORKFRONTTYPE_CONFIG = {
  entityName: 'WorkFrontType',
  localizationKey: 'Controlling::Entity.WorkFrontType',
  fields: WORKFRONTTYPE_FIELDS,
  permission: 'ControllingStructural.WorkFrontTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
